import { Pipe, PipeTransform } from "@angular/core";
import { DataTableColumn } from "../data-table.type";

@Pipe({ name: "cellRender" })
export class CellRenderPipe<T> implements PipeTransform {
  transform(_: unknown, value: unknown, row: T, column: DataTableColumn<T>): unknown {
    if (!column.render) {
      return value;
    }

    return column.render(row, column, value);
  }
}
